// @ts-ignore
import { synchroniseAsyncService } from '../ElmFramework/Lib/util';


export const graphqlSubscriptions = synchroniseAsyncService({
  service: import('./graphql-subscriptions'),
  api: ['handleGraphQLSubscriptions']
});